import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/about')({
  component: RouteComponent,
})

export default function RouteComponent() {
  return <div>Hello "/about"!</div>
}
